import { ClientJourneyValidationMetadata } from '../../../shared/validation/client-journey-validation-metadata';
import { ModelValidator } from '../../../shared/validation/model-validator';
import { MortgageRequest } from '../../../shared/models/deal-resources/mortgage-request.model';
import { ClientJourneyContext } from '../../../shared/services/deal/client-journey-context';
import {
  LoanType,
  PropertyFoundTypes,
} from '../../../shared/models/deal-resources/enumerators';
import { ValidatorRule } from 'src/app/utilities/validation/validation.interfaces';

export enum MortgageRequestValidationRules {
  Purpose = 'purpose',
  Type = 'type',
  FirstTimeBuyer = 'firstTimeBuyer',
}

export class MortgageRequestValidator extends ModelValidator<
  MortgageRequest,
  ClientJourneyValidationMetadata
> {
  private purposeValidationRule: ValidatorRule;
  get purposeIsValid(): boolean {
    return this.purposeValidationRule.isValid;
  }

  private typeValidationRule: ValidatorRule;
  get typeIsValid(): boolean {
    return this.typeValidationRule.isValid;
  }

  private firstTimeBuyerValidationRule: ValidatorRule;
  get firstTimeBuyerIsValid(): boolean {
    return this.firstTimeBuyerValidationRule.isValid;
  }

  constructor(
    mortgageRequest: MortgageRequest,
    clientJourneyContext: ClientJourneyContext,
  ) {
    super(mortgageRequest);

    let navigationMetadata = <ClientJourneyValidationMetadata>{
      blocksNavigation: true,
      showInMenu: true,
    };

    //purpose
    this.purposeValidationRule = this.ruleFor(
      mr => mr.purpose,
      MortgageRequestValidationRules.Purpose,
      navigationMetadata,
    ).must(purpose => purpose != null);

    //type
    this.typeValidationRule = this.ruleFor(
      mr => mr.type,
      MortgageRequestValidationRules.Type,
      navigationMetadata,
    )
      .when(mr => mr.purpose == LoanType.buy)
      .must(type => type != null);

    //first time buyer
    this.firstTimeBuyerValidationRule = this.ruleFor(
      mr => mr.type, //we don't need this field specified in this case
      MortgageRequestValidationRules.FirstTimeBuyer,
      navigationMetadata,
    )
      .when(
        mr => mr.purpose == LoanType.buy && mr.type == PropertyFoundTypes.yes,
      )
      .must(type => {
        let primaryBorrower = clientJourneyContext.deal.getPrimaryBorrower();
        return primaryBorrower.contact.firstTimeBuyer != null;
      });
  }
}
